import axios from "axios";

const baseUrl = process.env.REACT_APP_OCPW_ASSETWORKS_BASE_URL;

const flows = {
  omInspector: "om inspector",
};

const roadInspections = "roadInspections";
const channelInspections = "channelInspections";
const distanceFromDownstream = "DistanceDownstream";

interface IPhase {
  locationCode: string;
  sortCode: string;
  description: string;
  craftCode: string;
  longDesc: string;
  entClerk?: string;
  aePPhsEUdfDTOList?: [
    {
      _dtoName: string;
      sortCode: any;
      custom051: any;
      custom052: any;
    }
  ];
}
interface IWorkOrderRequest {
  contact: string;
  contactPh: string;
  contactMc: string;
  regionCode: string;
  description: string;
  bldg: string;
  statusCode: string;
  facId: string;
  category: string;
  orderType: string;
  flow: string;
  phases: IPhase[];
  referenceNo: string | null;
  entClerk?: string;
}
export interface IWorkOrderMapObject {
  request: IWorkOrderRequest;
  features: any[];
  attachFiles?: File[];
}

interface WorkOrder {
  proposal: string;
}
export const OcpwCreateWorkOrder = async ({
  dtoList,
  token,
}): Promise<{ dto: IWorkOrderMapObject; promise: Promise<any> }[]> => {
  try {
    const result = dtoList.map((dto) => ({
      dto,
      promise: axios.post(`${baseUrl}/work-order`, dto.request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }));

    return result;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response) {
      const err: any = error.response.data;
      throw new Error(`Error: ${err.message}`);
    } else {
      console.error(error);
      throw new Error(`${error.message}`);
    }
  }
};

export const getWorkOrderRequestDtoList = async ({
  data,
  portal,
  token,
  ocLandInsightsIdTable,
}): Promise<IWorkOrderMapObject[]> => {
  try {
    let requests: IWorkOrderMapObject[] = [];
    let workOrderMap = new Map<string, any>();
    let orderType: string;
    let category: string;
    let statusCode: string;
    let caseNumber: string = null;

    // Sort features by 'DistanceDownstream' if the field exists
    if (
      Array.isArray(data.features) &&
      data.features.length > 0 &&
      distanceFromDownstream in data.features[0].attributes
    ) {
      data.features = data.features.slice().sort((a, b) => {

        const aVal = a.attributes?.[distanceFromDownstream];
        const bVal = b.attributes?.[distanceFromDownstream];

        // Handle undefined/null values: treat them as greater (sort to end)
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return 1;
        if (bVal == null) return -1;

        return aVal - bVal;
      });
    }
    
    const storeAimLocationMap = new Map() 

    for (const feature of data.features) {
      let featureOCLandInsightsID =
        feature?.parentCustomParameters?.OCLandInsightsID;
      let propertyName: string;
      let workCode: string;
      let locationCode: string;
      let workOrderDescription: string;
      let phaseDescription: string;
      let phaseLongDescription: string;
      let contact: string;
      let workUnit: string;
      let estimatedWorkQuantity: any;
      let dimensions: any;
      let entClerk: string;
      if (
        featureOCLandInsightsID === ocLandInsightsIdTable[channelInspections] ||
        featureOCLandInsightsID === ocLandInsightsIdTable[roadInspections]
      ) {
        //need to use the id
        orderType = "PRO-SVCS";
        category = "CORRECTIVE";
        statusCode = "OPEN";

        const requiredAttributes = [
          "PropertyName",
          "WorkCode",
          "LocationCode",
          "RepairRecommendation",
          "EstimatedWorkQuantity",
          "WorkUnit",
          "DeficiencyLocation",
          "Latitude",
          "Longitude",
          // "LocationDescription",
          "ThomasGuide",
          "Inspector",
          "CaseNumber",
        ];
        // Validate that all required fields exist
        const missingAttributes = requiredAttributes.filter(
          (attr) => !(attr in feature.attributes)
        );
        if (missingAttributes.length > 0) {
          throw new Error(
            `Feature ${
              feature.attributes.OBJECTID
            } is missing required fields in the layer: ${missingAttributes.join(
              ", "
            )}`
          );
        }
        const requiredAttributeValue = [
          "PropertyName",
          "WorkCode",
          "LocationCode",
          "RepairRecommendation",
          "EstimatedWorkQuantity",
          "WorkUnit",
          "DeficiencyLocation",
          "Latitude",
          "Longitude",
          // "LocationDescription",
          "ThomasGuide",
          "Inspector",
        ];

        const missingAttributeValues = requiredAttributeValue.filter(
          (attr) =>
            feature.attributes[attr] === undefined ||
            feature.attributes[attr] === null
        );
        if (missingAttributeValues.length > 0) {
          throw new Error(
            `Feature ${
              feature.attributes.OBJECTID
            } is missing required attribute values: ${missingAttributeValues.join(
              ", "
            )}`
          );
        }

        const {
          OBJECTID,
          PropertyName,
          WorkCode,
          LocationCode,
          RepairRecommendation,
          EstimatedWorkQuantity,
          WorkUnit,
          DeficiencyLocation,
          Latitude,
          Longitude,
          LocationDescription,
          ThomasGuide,
          Inspector,
          CaseNumber,
          Dimensions
        } = feature.attributes;
        //const distanceDownstreamValue = feature.attributes?.[distanceFromDownstream];
        propertyName = PropertyName;
        workCode = WorkCode.toString();
        workUnit = WorkUnit;
        estimatedWorkQuantity = EstimatedWorkQuantity;
        locationCode = LocationCode;
        caseNumber = CaseNumber; // ? CaseNumber : caseNumber;
        dimensions = Dimensions;
        entClerk = Inspector
        //contact=Inspector
        workOrderDescription = `Property Name: ${propertyName} | ${caseNumber && caseNumber.length > 0 ? "\nCRM case Number " + caseNumber : ""}\n created by Inspections OC Land Insights`;
        phaseDescription =`Location: ${locationCode}`;
        phaseLongDescription = 
        `OBJECTID: ${OBJECTID}
        Repair Recommendation: ${RepairRecommendation}
        \n Est. Quantity: ${EstimatedWorkQuantity} ${WorkUnit}
        \n Dimensions: ${dimensions ? dimensions : "N/A"}
          \n deficiency location: ${DeficiencyLocation}
          \n Lat: ${Latitude}, Long: ${Longitude}
          \n Inspector: ${Inspector}
          \n CRM Case Number: ${caseNumber ? caseNumber: "N/A"}
          `;
      } else {
        continue; // Skip if layerName doesn't match
      }
      let body = {
        start: 0,
        batchSize: 1,
        columnSpecifications: [
          { property: "bldg" },
          { property: "regionCode" },
          { property: "facId" },
          { property: "locId" },
          { property: "locStatus" },
        ],
        query: {
          attributes: [
            {
              locationCode: { values: [locationCode], sqlOperator: "EQUAL" },
              locStatus: { values: ["ACTIVE"], sqlOperator: "EQUAL" },
            },
          ],
        },
      };

      // Check if location object already exist if not call the api
      let location;
      if(!storeAimLocationMap.has(locationCode)){
        const response = await axios.put(`${baseUrl}/location/list`, body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.results.length) {
          location = response.data.results[0];
          storeAimLocationMap.set(locationCode,location)
        } else {
          // Location code does not exist look into how to handle this error
          // console.log("location doesnt exist", locationCode);
          continue;
        }
      }
      else{
        location = storeAimLocationMap.get(locationCode);
      }

      if (workOrderMap.has(`${propertyName}-${workCode}`)) {
        let phases = workOrderMap.get(`${propertyName}-${workCode}`).request.phases;
        let features = workOrderMap.get(`${propertyName}-${workCode}`).features;
        // Check if a phase with the same locationCode and workCode already exists
        features.push(feature);

        const matchingPhases = phases.filter(phase =>
          phase.locationCode === locationCode &&
          phase.craftCode === workCode
        );
        if (matchingPhases.length === 0) {
          let sortCode = (phases.length + 1).toString().padStart(3, "0");
          feature.workOrderId = { sortCode: sortCode };
          phases.push({
            locationCode: locationCode,
            sortCode: sortCode,
            description: phaseDescription,
            craftCode: workCode,
            longDesc: phaseLongDescription,
            entClerk: entClerk,
            aePPhsEUdfDTOList: [
              {
                _dtoName: "aePPhsEUdfDTO",
                sortCode: sortCode,
                custom051: workUnit,
                custom052: estimatedWorkQuantity,
              },
            ],
          });
        } else {
          // For each matching phase, append phaseLongDescription and update custom052 if needed
          matchingPhases.forEach(phase => {
            // Append phaseLongDescription
            phase.longDesc = (phase.longDesc || "") + "\n" + phaseLongDescription;
            if (phase.sortCode !== '001' && Array.isArray(phase.aePPhsEUdfDTOList) && phase.aePPhsEUdfDTOList.length > 0) {
              const udf = phase.aePPhsEUdfDTOList[0];
              let currentVal = udf.custom052;
              let currentNum = 0;
              if (typeof currentVal === 'number') {
                currentNum = currentVal;
              } else if (typeof currentVal === 'string' && currentVal.trim() !== '') {
                currentNum = Number(currentVal);
                if (isNaN(currentNum)) currentNum = 0;
              }
              let addVal = 0;
              if (typeof estimatedWorkQuantity === 'number') {
                addVal = estimatedWorkQuantity;
              } else if (typeof estimatedWorkQuantity === 'string' && estimatedWorkQuantity.trim() !== '') {
                addVal = Number(estimatedWorkQuantity);
                if (isNaN(addVal)) addVal = 0;
              }
              udf.custom052 = (currentNum + addVal).toString();
            }
          });
        }
      } else {
        let sortCode1 = "001";
        let sortCode2 = "002";
        feature.workOrderId = { sortCode: sortCode1 };
        let features = [feature];
        let primaryPhase: IPhase = {
          locationCode: locationCode,
          sortCode: sortCode1,
          description: phaseDescription,
          craftCode: workCode,
          longDesc: phaseLongDescription,
          entClerk: entClerk,
          aePPhsEUdfDTOList: [
            {
              _dtoName: "aePPhsEUdfDTO",
              sortCode: sortCode1,
              custom051: "",//workUnit,
              custom052: "",//estimatedWorkQuantity,
            },
          ],
        };

        let secondaryPhase: IPhase = {
          locationCode: locationCode,
          sortCode: sortCode2,
          description: phaseDescription,
          craftCode: workCode,
          longDesc: phaseLongDescription,
          entClerk: entClerk,
          aePPhsEUdfDTOList: [
            {
              _dtoName: "aePPhsEUdfDTO",
              sortCode: sortCode2,
              custom051: workUnit,
              custom052: estimatedWorkQuantity,
            },
          ],
        };
        let requestObject: IWorkOrderRequest = {
          flow: flows.omInspector,
          contact: contact, //portal?.user?.fullName.length ? portal.user.fullName : "Area Inspector",
          contactPh: "",
          contactMc: "", //portal?.user?.email.length ? portal.user.email : "james.wallace2@ocpw.ocgov.com",
          entClerk: entClerk,
          regionCode: location.regionCode,
          bldg: location.bldg,
          statusCode: statusCode,
          description: workOrderDescription,
          facId: location.facId,
          category: category,
          orderType: orderType,
          referenceNo: caseNumber,
          phases: [primaryPhase, secondaryPhase],
        };

        workOrderMap.set(`${propertyName}-${workCode}`, {
          features: features,
          request: requestObject,
        });
      }
    }
    workOrderMap.forEach((value) => {
      requests.push(value);
    });
    return requests;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(`${error.message}`);
    } else {
      console.error("blah", error);
      throw new Error(`${error.message}`);
    }
  }
};

export const uploadAttachmentToAim = async ({
  token,
  file,
}: {
  proposal: string;
  token: string;
  file: File;
}) => {
  try {
    // 1. Upload the document
    const formData = new FormData();
    formData.append("documentName", file.name);
    formData.append("mimeType", file.type);
    formData.append("content", file);
    formData.append("fileName", file.name);

    const uploadResponse = await axios.post(
      `${baseUrl}/document/upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return uploadResponse;
  } catch (error: any) {
    if (axios.isAxiosError(error) && error.response) {
      const err: any = error.response.data;
      throw new Error(`Error: ${err.message}`);
    } else {
      throw new Error(error.message);
    }
  }
};

export const linkAttachmentToWorkOrder = async ({
  proposal,
  documentSeriesIds,
  token,
}: {
  proposal: string;
  documentSeriesIds: string[];
  token: string;
}) => {
  if (proposal && documentSeriesIds.length > 0) {
    // 2. Link the document to the work order
    let linkBody = {
      primaryKey: { proposal },
      documentSeriesIds: documentSeriesIds,
    };
    const linkResponse = await axios.post(
      `${baseUrl}/link/work-order`,
      linkBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (
      linkResponse.status !== 200 &&
      !linkResponse.data &&
      Object.keys(linkResponse.data).length !== 0
    ) {
          return {
      documentSeriesIds,
      linked: false,
      proposal,
    }

    }
    return {
      documentSeriesIds,
      linked: true,
      proposal,
    };
  } else {
    throw new Error("missing parameters to link document to work order");
  }
};
